import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import Panel from '../../../../../../components/angle/Panel/index';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import ProspectusForm from '../../components/ProspectusForm';
import { formInputValidation } from '../../../../../../services/helper/form-helper';

import {
    editProspectus,
    updateEditProspectusPayload,
    updateProspectusHistoryItemSelected,
    handleEditProspectusVisibility
} from '../../../../../../services/redux/employee/prospectus/actions';

class EditProspectus extends Component {
    constructor(props) {
        super(props);
        this.prospectusFormRef = React.createRef();
        this.onSaveClick = this.onSaveClick.bind(this);
        this.onBackClick = this.onBackClick.bind(this);
    }

    onSaveClick() {
        let {
            prospectus,
            handleEditProspectusVisibility,
            editProspectus
        } = this.props;
        let payload = prospectus.editProspectusData;
        if (formInputValidation(this.prospectusFormRef.current)) {
            editProspectus(payload).then(response => {
                if (response.status === 200) {
                    handleEditProspectusVisibility(false);
                }
            });
        }
    }

    onBackClick() {
        let { handleEditProspectusVisibility, location, history } = this.props;
        if (location.from && location.from !== '/client-details') {
            history.push({
                pathname: location.from,
                from: '/client-details'
            });
        } else {
            handleEditProspectusVisibility(false);
        }
    }

    render() {
        let { prospectus, updateEditProspectusPayload } = this.props;
        let saveButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered green-button"
                onClick={this.onSaveClick}
            >
                Save
            </button>
        );

        let backButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered green-button"
                onClick={this.onBackClick}
            >
                Back
            </button>
        );

        return (
            <div className="panel">
                <Tabs
                    defaultActiveKey={1}
                    id="tabID"
                    mountOnEnter={true}
                    unmountOnExit={true}
                >
                    <Tab eventKey={1} title="Edit Prospectus">
                        <Panel>
                            <div className="col-lg-6 col-md-8 col-sm-12">
                                <ProspectusForm
                                    prospectusData={
                                        prospectus.editProspectusData
                                    }
                                    updateProspectusData={
                                        updateEditProspectusPayload
                                    }
                                    formRef={this.prospectusFormRef}
                                />
                            </div>
                        </Panel>
                    </Tab>
                    <br />
                    {saveButton}
                    {backButton}
                </Tabs>
                {prospectus.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    prospectus: state.employee.prospectus
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            editProspectus,
            updateEditProspectusPayload,
            updateProspectusHistoryItemSelected,
            handleEditProspectusVisibility
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(EditProspectus));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientDetails/screens/EditProspectus/index.js